import React from 'react';
import GlobalProps from '../../../components/globalProps';
import { patchCompany, Company, CompanyPatch } from '../../../model/company';
import { handleError } from '../../../model/notification';
import { t } from '../../../locales/translate';
import { Stack } from '../../../components/Stack/Stack';
import { Grid } from '../../../components/Grid/Grid';
import { useForm } from '@nerdgeschoss/react-use-form-library';
import { FormForm } from '../../../components/Form/FormForm';
import { FormTextField } from '../../../components/Form/TextField/FormTextField';

interface Props extends GlobalProps {
  company: Company;
  onClose: () => void;
}

interface CompanyModel extends Company {
  bankAccount: {
    name?: string | null;
    iban?: string | null;
    bic?: string | null;
    bankName?: string | null;
  };
}

export function BankDetailsForm({ company, onClose }: Props): JSX.Element {
  const { model, fields, valid, dirty, onSubmit, submissionStatus } = useForm<CompanyModel>({
    model: company,
    onSubmit: async () => {
      await patchCompany(company.id, model as CompanyPatch);
      onClose();
    },
    onSubmitError: (error) => handleError(error),
  });

  return (
    <FormForm
      onSubmit={onSubmit}
      className="companies-modal__form"
      canSubmit={dirty && valid}
      loading={submissionStatus === 'submitting'}
      onClose={onClose}
    >
      <Stack>
        <Grid gap="default">
          <FormTextField {...fields.vatId} label={t.model.bank.vat} />
          <FormTextField {...fields.vatNumber} label={t.model.bank.taxNumber} />
        </Grid>
        <FormTextField {...fields.merchCreditorReference} label={t.model.reference.merchCreditorReference} />
        <FormTextField {...fields.eventCreditorReference} label={t.model.reference.eventCreditorReference} />
        <FormTextField {...fields.bankAccount.fields.name} label={t.model.user.name} />
        <Grid gap="default">
          <FormTextField {...fields.bankAccount.fields.iban} label={t.model.bank.iban} />
          <FormTextField {...fields.bankAccount.fields.bic} label={t.model.bank.bic} />
        </Grid>
        <FormTextField {...fields.bankAccount.fields.bankName} label={t.model.bank.bankName} />
      </Stack>
    </FormForm>
  );
}
